import { logLevels } from './constants'

/**
 * Helper function to validate a "log level" string before its used in the library.
 * @method checkLevel
 * @param  {string} level A log level provided by a user.
 * @return {string}       The log level as expected by the library.
 * @throws Will throw an error if the `level` parameter is invalid.
 */
export function checkLevel (level) {
  // Ensure: is defined and is a string.
  const upperLevel = level && level.toUpperCase && level.toUpperCase()

  // Ensure: is a supported log level.
  if (upperLevel && logLevels[upperLevel]) {
    return logLevels[upperLevel]
  } else {
    throw new Error('Provided level is not a valid log level.')
  }
}

/**
 * Helper function to validate a "log handler".
 * Basically just "is function" that throws an error if false.
 * @method checkHandler
 * @param  {Function} handler A log handler function, ideally.
 * @return {Function}         The same log handler function, ideally.
 * @throws Will throw an error if the `handler` provided is not a function.
 */
export function checkHandler (handler) {
  if (handler && typeof handler === 'function') {
    return handler
  } else {
    throw new Error('Provided log handler is not a function.')
  }
}
